module.exports = __webpack_public_path__ + "static/media/whyThree.602d2851.jpg";